import _objectSpread from "/home/jenkins/workspace/tServices_Forms_Client_CICD_main/node_modules/babel-preset-react-app/node_modules/@babel/runtime/helpers/esm/objectSpread2";
import { jsx } from 'react/jsx-runtime';
import * as DropdownMenuPrimitive from '@radix-ui/react-dropdown-menu';
import { forwardRef } from 'react';
/**
 * Based on Radix-UI Group
 * @see https://www.radix-ui.com/docs/primitives/components/dropdown-menu#group
 */

var DropdownMenuGroup = /*#__PURE__*/forwardRef(function (props, forwardedRef) {
  return jsx(DropdownMenuPrimitive.Group, _objectSpread(_objectSpread({}, props), {}, {
    ref: forwardedRef
  }));
});
DropdownMenuGroup.displayName = 'DropdownMenuGroup';
export { DropdownMenuGroup };